export default {
    endometriosisPelvicUs: 'endometriosisPelvicUs',
    indication: 'indication',
    examinationMethod: 'examinationMethod',
    examinationView: 'examinationView',
    bladderNoduleLog: "bladderNoduleLog",
    uterusPosition: "uterusPosition",
    uterusSize: "uterusSize",
    uterusAdenomyosisTest: "uterusAdenomyosisTest",
    endometriumTest: "endometriumTest",
    endometriumType: "endometriumType",
    endometriumIsoTest: "endometriumIsoTest",
    endometriumMeasuredCM: "endometriumMeasuredCM",
    endometriumMeasuredMM: "endometriumMeasuredMM",
    endometriumMeasuredDay: "endometriumMeasuredDay",
    fibroType: "fibroType",
    polypType: "polypType",
    threeDCoronal: "threeD Coronal",
    rightOvaryMM1: "rightOvaryMM1",
    rightOvaryMM2: "rightOvaryMM2",
    rightOvaryContain: "rightOvaryContain",
    rightEndometriomaType: "rightEndometriomaType",
    rightOvarianAdhesionType: "rightOvarianAdhesionType",
    leftOvaryMM1: "leftOvaryMM1",
    leftOvaryMM2: "leftOvaryMM2",
    leftOvaryContain: "leftOvaryContain",
    leftOvarianAdhesionType: "leftOvarianAdhesionType",
    leftEndometriomaType: "leftEndometriomaType",
    dopplerStudyType: "dopplerStudyType",
    pouchDouglasType: "pouchDouglasType",
    uteroSacralLigamentNoduleType: "uteroSacralLigamentNoduleType",
    rectoSigmoNoduleType: "rectoSigmoNoduleType",
    tendernessWithTheProbeType: "tendernessWithTheProbeType",
    commentType: "commentType",
    impressionLocation: "impressionLocation",
    finalDescription: "finalDescription"
}